import classNames from 'classnames';
import { useController } from 'react-hook-form';

import css from './select.css';

export interface SelectProps {
  options: {
    label: string;
    value: string;
  }[];
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  className?: string;
}

const deselectKey = 'none';

const Select = ({ label, options, value = deselectKey, onChange, placeholder, className }: SelectProps) => {
  const onValueChange = (newValue: string) => {
    if (newValue === deselectKey) {
      onChange?.('');
    } else {
      onChange?.(newValue);
    }
  };

  return (
    <div className={classNames(css.wrapper, className)}>
      {label && <span className={css.span}>{label}</span>}

      <select value={value} onChange={(e) => onValueChange(e.target.value)} className={css.select}>
        <option value={deselectKey}>{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

type ControlledSelectProps = Omit<SelectProps, 'name' | 'onChange'> & { name: string };

export const ControlledSelect = ({ name, ...props }: ControlledSelectProps) => {
  const { field } = useController({ name });

  return <Select {...props} value={field.value} onChange={field.onChange} />;
};

export default Select;
